import {
  PATH_NAME_LIST_ADULT_CHECK, PATH_NAME_SEARCH,
  PATH_NAME_SEARCH_LIST,
  PATH_NAME_SEARCH_TAG, PATH_NAME_SEARCH_TAG_GROUP
} from '@/common/router.const'

export default [
  {
    path: '/search',
    name: PATH_NAME_SEARCH,
    components: {
      search: () => import('@/components/search/Search')
    },
    props: true
  },
  // {
  //   path: '/search/category',
  //   name: PATH_NAME_CATEGORY_SEARCH,
  //   components: {
  //     category_search: () => import('@/components/search/CategorySearchView')
  //   },
  //   children: [
  //     {
  //       path: 'adultcheck',
  //       name: PATH_NAME_CATEGORY_ADULT_CHECK,
  //       components: {
  //         adult: () => import('@/views/adult/Adult')
  //       }
  //     }
  //   ]
  // },
  {
    path: '/search/list/:section',
    name: PATH_NAME_SEARCH_LIST,
    components: {
      list: () => import(/* webpackChunkName: "viewMoreSearch" */'@/views/viewmore/List')
    },
    props: true,
    children: [
      {
        path: 'adultcheck',
        name: PATH_NAME_LIST_ADULT_CHECK,
        components: {
          adult: () => import('@/views/adult/Adult')
        }
      }
    ]
  },
  {
    path: '/search/search_tag',
    name: PATH_NAME_SEARCH_TAG,
    components: {
      search: () => import('@/components/search/SearchTag')
    }
  },
  {
    path: '/search/search_tag_group',
    name: PATH_NAME_SEARCH_TAG_GROUP,
    components: {
      search: () => import('@/components/search/SearchTagGroup')
    }
  }
]
